import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSuffix } from '@angular/material/form-field';
import { chain, isNil } from 'lodash';

export type WorkOrderUnsavedChangesDialogData = Record<string, boolean>;

const TAB_TRANSLATION_MAP: Record<string, string> = {
  hasChangedActivities: 'ACTIVITIES',
  hasUnsavedComment: 'ACTIVITIES',
  hasUnsavedAttachments: 'ATTACHMENTS',
};

@Component({
  templateUrl: 'work-order-unsaved-changes-dialog.component.html',
  styleUrl: 'work-order-unsaved-changes-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    MatSuffix,
    TranslatePipe,
  ],
})
export class WorkOrderUnsavedChangesDialogComponent {
  protected readonly tabs: string;

  constructor() {
    const unsavedChangesState = inject<WorkOrderUnsavedChangesDialogData>(MAT_DIALOG_DATA);
    const translateService = inject(TranslateService);

    this.tabs = chain(unsavedChangesState)
      .entries()
      .filter(([, value]) => value)
      .map(([key]) => TAB_TRANSLATION_MAP[key])
      .filter(translation => !isNil(translation))
      .map(translation => translateService.instant(translation))
      .uniq()
      .join(', ')
      .value();
  }
}
